module.exports = __webpack_public_path__ + "img/invite-friends.25b4f987.jpg";